import template from './rsvp-guests.tpl.html';
import rsvpSingleMessageModalCreator from '../../../modules/messages/helpers/rsvp-single-message-modal-creator';

class RsvpGuestsCtrl {
    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;

        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.modal = this.injector.get('$uibModal');
        this.params = _.cloneDeep(this.injector.get('$stateParams'));
        this.acl = this.injector.get('Acl');
        this.rsvpsStore = this.injector.get('Rsvps').create('RsvpGuestBaseStore');
        this.translate = this.injector.get('$translate');
        this.currentStore = null;
        this.rsvp = null;
        this.currentGuests = [];

        this.loading = true;
        this._initWatchers();
        // this._loadGuests();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.rsvp;
        }, () => {
            if (this.rsvp) {
                this._loadGuests();
            }
        })
    }

    _loadGuests() {
        this.loading = true;
        this.currentGuests = [];
        this.currentStore = this.rsvpsStore.reset({
            persist: false,
            listview: 'Rsvp' + this.rsvp.id + 'Guests'
        });

        this.currentStore.commit('setSlug', 'rsvps/' + this.rsvp.id + '/child');

        this.currentStore.commit('setPermanentFilters', {
            'guestlist.id': this.rsvp.guestlist_id,
            'parent_rsvp_id': this.rsvp.id
        });
        this.currentStore.commit('setTitle', 'Guests of rsvp #' + this.rsvp.id);
        this.currentStore.commit('setPermanentFilters', {
            'guestlist.id': this.rsvp.guestlist_id,
            'parent_rsvp.id': this.rsvp.id
        });
        this.currentStore.resetGetters();

        this.currentStore.commit('setVisible', [
            'contact.full_name',
            'contact.preferred_email',
            'contact.email',
            'contact.business_email',
            'status',
            'code',
            'guestlist_id',
            'contact.id'
        ]);
        this.currentStore.commit('setSort', {'contact.full_name': 'asc'});

        this.currentStore.dispatch('getDefinitions').then(() => {
            this.currentStore.dispatch('getData').then(() => {
                this.currentGuests = this.currentStore.state.data;
                this.loading = false;
            })
        });
    }

    openRsvpDetails(rsvp) {
        this.state.go('app.guestlists.rsvps.details.overview', {
            gid: this.rsvp.guestlist.data.id,
            id: rsvp.id,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    goToGuestView(rsvp) {
        this.state.go('app.guestlists.rsvps.details.guests', {
            gid: this.rsvp.guestlist.data.id,
            id: rsvp.id,
            store: this.store
        });
    }

    editRsvp(rsvp) {
        this.state.go('app.guestlists.rsvps.details.edit', {
            gid: this.rsvp.guestlist.data.id,
            id: rsvp.id,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    deleteRsvp(rsvp) {
        const translatedValue = (path) => {
            return this.translate.instant(`components.ask-to-archive-guest.${path}`);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content'),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            })
            .then(() => {
                this.api.delete(`rsvps/${rsvp.id}`, {
                    data: {
                        force: false
                    }
                }).then(() => {
                    this._loadGuests();
                    return this.alert.success(`Successfully archived guest.`);
                }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }


    sendEmail(rsvpToSend) {
        this.injector.get('$q').all([
            this.api.get(`rsvps/${rsvpToSend.id}`).then((response) => {
                return response.data.data;
            }),
            this.api.get(`contacts/${rsvpToSend.contact.id}`).then((response) => {
                return response.data.data;
            }),
            this.api.get(`guestlists/${rsvpToSend.guestlist_id}`).then((response) => {
                return response.data.data;
            })
        ]).then((models) => {
            rsvpSingleMessageModalCreator(this.injector, models[0], models[1], {
                guestlist: models[2]
            });
        })
    }
}

RsvpGuestsCtrl.$inject = [
    '$injector',
    '$scope'
];

angular
    .module('festzelt-os.components')
    .component('rsvpGuests', {
        bindings: {
            rsvp: '<',
            store: '=',
            headline: '@',
            hideActions: '<',
            reloadAction: '&'
        },
        controller: RsvpGuestsCtrl,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/rsvp-guests/rsvp-guests.js